module.exports = __webpack_public_path__ + "media/assets/6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/6.svg
// module id = 18
// module chunks = 0